// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TitleComponent_titleContainer__1HFZI","titleIcon":"TitleComponent_titleIcon__L0Zto","titleText":"TitleComponent_titleText__dK934"};